// Impression and click beacons. Sent as text/plain so the cross-origin request is
// a "simple" one with no preflight, and with sendBeacon where it exists so a click
// that navigates away still gets counted.

declare global {
  interface Window {
    __hrnFormsImpressions?: Set<string>;
  }
}

function send(url: string, body: string): void {
  try {
    if (navigator.sendBeacon?.(url, new Blob([body], { type: "text/plain" }))) return;
  } catch {
    /* fall through to fetch */
  }
  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "text/plain" },
    body,
    keepalive: true,
    credentials: "omit",
  }).catch(() => {});
}

/** Counted once per form per page load, however many instances render. */
export function trackImpression(apiBase: string, formId: string, variantId: string): void {
  const seen = ((globalThis as unknown as Window).__hrnFormsImpressions ??= new Set<string>());
  if (seen.has(formId)) return;
  seen.add(formId);
  send(`${apiBase}/impression`, JSON.stringify({ formId, variantId }));
}

/** A click on a link block's button: the conversion for a block that collects nothing. */
export function trackClick(apiBase: string, formId: string, variantId: string): void {
  send(`${apiBase}/click`, JSON.stringify({ formId, variantId }));
}

/** A landing page load, with the page variant the visitor was shown. Once per page load. */
export function trackPageView(apiBase: string, pageId: string, pageVariantId: string): void {
  send(`${apiBase}/page-view`, JSON.stringify({ formId: pageId, variantId: pageVariantId }));
}

/**
 * A click on one of a landing page's buttons, named by `label` (the form card's
 * is "form" unless its placeholder named it): that page's conversion, and a
 * per-button count.
 */
export function trackPageClick(apiBase: string, pageId: string, pageVariantId: string, label: string): void {
  send(`${apiBase}/page-click`, JSON.stringify({ formId: pageId, variantId: pageVariantId, label }));
}
